export const MOBILE_VIEW_TYPE = {
  INBOX: "inbox",
  CALENDAR: "calendar",
} as const;

export type mobileViewType = (typeof MOBILE_VIEW_TYPE)[keyof typeof MOBILE_VIEW_TYPE];
